import {Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl } from '@angular/forms';
import { ServicePointService } from '../../services/service-point.service';
import {concat, Observable, of, Subject} from "rxjs";
import { ServicePoint } from '../../model/servicePoint';
import {catchError, distinctUntilChanged, switchMap, tap} from "rxjs/operators";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'auth-suite-services-app-gid-select',
  templateUrl: './gid-select.component.html',
  styleUrls: ['./gid-select.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GidSelectComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => GidSelectComponent),
      multi: true,
    }]
})
export class GidSelectComponent implements OnInit, ControlValueAccessor {

  servicePoints$!: Observable<ServicePoint[]>
  spsLoading = false;
  spsInput$ = new Subject<string>();
  multiple = false;
  maxItems = 20;

  itemList: any = [];
  selectedItems = [];
  selectedItemsEmpty = true;

  settings = {
    text: 'Select Service Points',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: 'myclass custom-class',
    primaryKey: 'id',
    labelKey: 'globalID',
    noDataLabel: 'Search Service Points...',
    enableSearchFilter: true,
    searchBy: ['globalID', 'servicePointName'],
    singleSelection: false,
    searchAutofocus: true
  };

  @Input() set singleSelection(val :any) {
    this.settings.singleSelection = val;
    if (val) {
      this.maxItems = 1;
    }
  }

  constructor(private _spsService: ServicePointService) { }

  ngOnInit() {
    // this.settings = {
    //   text: 'Select Service Points',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   classes: 'myclass custom-class',
    //   primaryKey: 'id',
    //   labelKey: 'globalID',
    //   noDataLabel: 'Search Service Points...',
    //   enableSearchFilter: true,
    //   searchBy: ['globalID', 'servicePointName'],
    //   singleSelection: false,
    //   searchAutofocus: true
    // };
    this.loadServicePoints();
  }

  trackByFn(item: ServicePoint) {
    return item.id;
  }

  private loadServicePoints() {
    this.servicePoints$ = concat(
        of([]), // default items
        this.spsInput$.pipe(
            distinctUntilChanged(),
            tap(() => this.spsLoading = true),
            switchMap(term => this._spsService.getServicePointsSelect(term).pipe(
                catchError(() => of([])), // empty list on error
                tap(() => this.spsLoading = false)
            ))
        )
    );
  }

  // this is the initial value set to the component
  public writeValue(obj: any) {
    if (obj) {
      // console.log('writeValue');
      // console.log(obj);
      this.selectedItems = obj;
      this.itemList = obj;
    }
  }

  // validates the form, returns null when valid else the validation object
  // in this case we're checking if the json parsing has passed or failed from the onChange method
  public validate(c: FormControl) {
    if (c.validator?.hasOwnProperty('required')) {
      return (!this.selectedItemsEmpty) ? null : {
        required: {
          valid: false,
        },
      };
    }
    return null;
  }

  // registers 'fn' that will be fired web changes are made
  // this is how we emit the changes back to the form
  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  // not used, used for touch input
  public registerOnTouched(fn: any) {
    // this.propagateChange = fn;
  }

  // change events from the select
  private onChange(event: any) {

    // get value from text area
    // const newValue = event.target.value;
    // console.log(`newValue: ${newValue}`);
    // update the form
    this.propagateChange(this.selectedItems);
  }

  // the method set in registerOnChange to emit changes back to the form
  private propagateChange = (_: any) => { };

  onItemSelect(item: any) {
    console.log('onItemSelect',item);
    console.log('selectedItems',this.selectedItems);
    this.selectedItemsEmpty = this.selectedItems.length <= 0;
    this.propagateChange(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    // console.log(item);
    // console.log(this.selectedItems);
    this.selectedItemsEmpty = this.selectedItems.length <= 0;
    this.propagateChange(this.selectedItems);
  }
  onSelectAll(items: any) {
    // console.log(items);
    this.selectedItemsEmpty = this.selectedItems.length <= 0;
    this.propagateChange(this.selectedItems);
  }
  onDeSelectAll(items: any) {
    // console.log(items);
    this.selectedItemsEmpty = this.selectedItems.length <= 0;
    this.propagateChange(this.selectedItems);
  }
  onSearch(evt: any) {
    // console.log(evt.target.value);
    this.itemList = [];
    this._spsService.getServicePointsSelect(evt.target.value)
      .subscribe( data => {
        this.itemList = data;
      });
  }

  // onSearch(evt: any) {
  //   // console.log(evt.target.value);
  //   this.itemList = [];
  //   this._spsService.getServicePointsSelect(evt.target.value)
  //       .subscribe( data => {
  //         if (data) {
  //           for (let i = 0; i < data.length; i++) {
  //             this.itemList.push(data[i]);
  //           }
  //         }
  //       });
  // }
  keyFn(event: KeyboardEvent) {
    console.log('event', event)
  }
}
